import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ImageContext = createContext();

export const useImageContext = () => useContext(ImageContext);

/**
 * Shared state for the VIMDT feature routes: the loaded image list and the API key.
 */
export function ImageProvider({ children }) {
	const [imageList, setImageList] = useState({});
	const [apikey, setApikey] = useState('');
	const [background, setBackground] = useState(false);
	// Per-tab API keys, keyed by tab path, so each tab remembers its own entry across route unmount/remount.
	const [tabApikeys, setTabApikeys] = useState({});

	const setTabApikey = useCallback((tab, value) => {
		setTabApikeys((prev) => (prev[tab] === value ? prev : { ...prev, [tab]: value }));
	}, []);

	const contextValue = useMemo(
		() => ({
			imageList,
			setImageList,
			apikey,
			setApikey,
			background,
			setBackground,
			tabApikeys,
			setTabApikey,
		}),
		[imageList, apikey, background, tabApikeys]
	);

	return <ImageContext.Provider value={contextValue}>{children}</ImageContext.Provider>;
}

export default ImageProvider;
